import languagesData from '../data/languages.json';
 function Data (languages = languagesData) {
    return languages;
}

export default Data;